import { toast } from 'react-toastify';
import {
  API_KEYS_SUCCESS,
  API_KEYS_CREATE,
  API_KEYS_DELETE,
} from '../constants/actions';

export function loadApiKeys(user) {
  return (dispatch) => {
    // Call the club api to find the users.
    window.usersApi.get(`/v1/admin/users/${user.uuid}/api_keys`)
      .then((response) => {
        dispatch({ type: API_KEYS_SUCCESS, data: response.data });
      })
      .catch((response) => {
        // TODO
      });
  };
}

export function createApiKey(user) {
  return (dispatch) => {
    // Call the club api to find the users.
    window.usersApi.post(`/v1/admin/users/${user.uuid}/api_keys`)
      .then((response) => {
        dispatch({ type: API_KEYS_CREATE, token: response.data });

        toast.success('Created new API key');
      })
      .catch((response) => {
        // TODO
      });
  };
}


export function deleteApiKey(user_id, token) {
  return (dispatch) => {
    // Call the club api to find the users.
    window.usersApi.delete(`/v1/admin/users/${user_id}/api_keys/${token}`)
      .then((response) => {
        if (response.status < 300) {
          toast.success("Successfully deleted API key");
           dispatch({ type: API_KEYS_DELETE, data: token });
        } else {
          throw new Error("Wrong status code");
        }
      })
      .catch((response) => {
        toast.error("Failed deleting API key");
      });
  };
}
